// extracted by mini-css-extract-plugin
module.exports = {"heading":"GemDetail_heading__2Z5rW","list":"GemDetail_list__6beQy","li":"GemDetail_li__3e2NY"};